/*! Blog Block 10b — lazy-load Trustpilot bootstrap once any widget enters view */
(function () {
  if (window.__blogTpProofObserverAttached) return;
  window.__blogTpProofObserverAttached = true;

  function tpScriptSrc() {
    return 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  }

  function loadBootstrap() {
    if (window.__blogTrustpilotLoaded) return;
    window.__blogTrustpilotLoaded = true;
    var s = document.createElement('script');
    s.src = tpScriptSrc();
    s.async = true;
    document.head.appendChild(s);
  }

  var widgets = document.querySelectorAll('.blog-trustpilot-proof .trustpilot-widget');
  if (!widgets.length) return;

  if (!('IntersectionObserver' in window)) {
    loadBootstrap();
    return;
  }

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadBootstrap();
          obs.disconnect();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  widgets.forEach(function (w) {
    io.observe(w);
  });
})();
